import React from 'react';

// 财务付款记录
const FinancePaymentRecord = () => {
    return <div>FinancePaymentRecord</div>;
};

export default FinancePaymentRecord;
